export const MediaFile = {
    JavaBattleship: 'JavaBattleship',
    PcBuilder: 'PCBuilder',
    PublicTransportVehicleEstimator: 'PublicTransportVehicleEstimator',
    MyPortfolio: 'MyPortfolio',
    ComingSoon: 'ComingSoon',
} as const